import React, { Fragment, useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPage, toggleSelect } from '../Actions/Library.action';
import Pagination from './Pagination';
import { calculatePager } from '../Services/Pagination.service';

const LibraryPhotos = () => {
  const dispatch = useDispatch();
  const [pager, setPager] = useState({});
  const { photos, selected, pageNumber } = useSelector(
    (state) => state.library
  );
  useEffect(() => {
    setPager(calculatePager(photos.total, pageNumber, { pageSize: 10 }));
  }, [photos]);
  const changePageIndex = (index) => {
    dispatch(setPage(index));
  };
  const handleCheckbox = (photoId) => {
    const _selected = [...selected];
    const index = _selected.indexOf(photoId);
    if (index !== -1) {
      _selected.splice(index, 1);
    } else {
      _selected.push(photoId);
    }
    dispatch(toggleSelect(_selected));
  };
  const selectAll = () => {
    if (selected.length < photos.items?.value.length) {
      const allIds = [];
      photos.items?.value.forEach((item) => allIds.push(item.id));
      dispatch(toggleSelect(allIds));
    } else if (
      selected.length > 0 &&
      selected.length === photos.items?.value.length
    ) {
      dispatch(toggleSelect([]));
    }
  };
  return (
    <Fragment>
      <div className="row library__top">
        <div className="columns small-12">
          <input
            type="checkbox"
            checked={
              selected.length > 0 &&
              selected.length === photos.items?.value.length
            }
            onChange={selectAll}
          />
          Select all
        </div>
      </div>
      <div className="row library__photos">
        {photos.items?.value?.map((photo, index) => (
          <div
            key={photo.id}
            className="columns small-12 medium-3 large-4 library__photo"
          >
            <div className="library__photo--item">
              <input
                type="checkbox"
                checked={selected.includes(photo.id)}
                onChange={(e) => handleCheckbox(photo.id)}
              />
              <a href={photo.url} className="library__photo--download" download>
                <img src={photo.url} />
                <div className="photoDownloadIcon"></div>
              </a>
            </div>
            <div className="library__photo--name">{photo.description ?? photo.name}</div>
          </div>
        ))}
      </div>
      <Pagination model={pager} onChange={changePageIndex} />
      {photos.items?.value.length === 0 ? (
        <div className="columns small-12 library__notFound">
          No photos found. Please try another search filter.
        </div>
      ) : (
        ''
      )}
    </Fragment>
  );
};

export default LibraryPhotos;
